import { useEffect } from "react";
import { useLazyGetCustomerActiveLoanDetailsQuery } from "../../../service/customer-service";
import styles from "./AdminCustomerDetailsPage.module.scss";
import { toast } from "react-toastify";

export interface ProductDetailsProps {
    customerId: string;
}

const ProductDetail: React.FC<ProductDetailsProps> = ({ customerId }) => {

    return (
        <div className={styles.activeLoanContainer}>
            <div className={styles.row}>
                <div className={styles.column}>Product Name</div>
                <div className={styles.column}>-</div>
            </div>
            <div className={styles.row}>
                <div className={styles.column}>cost per kWh</div>
                <div className={styles.column}>-</div>
            </div>
            <div className={styles.row}>
                <div className={styles.column}>Order Date</div>
                <div className={styles.column}>
                   -
                </div>
            </div>
            <div className={styles.row}>
                <div className={styles.column}>Installation Date</div>
                <div className={styles.column}>-</div>
            </div>
            <div className={styles.row}>
                <div className={styles.column}>Activation Date</div>
                <div className={styles.column}>-</div>
            </div>
        </div>
    );
};
export default ProductDetail;
